import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../js/compareTo.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../js/charSequenceJs.mjs';
import { uppercaseChar6lahngw3wvwg as uppercaseChar } from './charJs.mjs';
import {
  toString1n9qg6fb0b5i8 as toString,
  Char__compareTo_impl_ypi4mb3bl0kdwnivnp6 as Char__compareTo_impl_ypi4mb,
} from '../Char.mjs';
import { Companion_instance2ztfx9zvq7j5d as Companion_instance } from '../collections/AbstractList.mjs';
import {
  encodeUtf82ot7wguqzn94o as encodeUtf8,
  decodeUtf82vk39mtae8m3q as decodeUtf8,
} from './utf8Encoding.mjs';
import { charArray2ujmm1qusno00 as charArray } from '../js/arrays.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../ComparatorJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var STRING_CASE_INSENSITIVE_ORDER;
function substring(_this__u8e3s4, startIndex, endIndex) {
  _init_properties_stringJs_kt__bg7zye();
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.substring(startIndex, endIndex);
}
function substring_0(_this__u8e3s4, startIndex) {
  _init_properties_stringJs_kt__bg7zye();
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.substring(startIndex);
}
function compareTo_0(_this__u8e3s4, other, ignoreCase) {
  ignoreCase = ignoreCase === VOID ? false : ignoreCase;
  _init_properties_stringJs_kt__bg7zye();
  if (ignoreCase) {
    var n1 = _this__u8e3s4.length;
    var n2 = other.length;
    // Inline function 'kotlin.comparisons.minOf' call
    var min = Math.min(n1, n2);
    if (min === 0)
      return n1 - n2 | 0;
    var inductionVariable = 0;
    if (inductionVariable < min)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var thisChar = charCodeAt(_this__u8e3s4, index);
        var otherChar = charCodeAt(other, index);
        if (!(thisChar === otherChar)) {
          thisChar = uppercaseChar(thisChar);
          otherChar = uppercaseChar(otherChar);
          if (!(thisChar === otherChar)) {
            // Inline function 'kotlin.text.lowercaseChar' call
            // Inline function 'kotlin.text.lowercase' call
            var this_0 = thisChar;
            // Inline function 'kotlin.js.asDynamic' call
            // Inline function 'kotlin.js.unsafeCast' call
            var tmp$ret$2 = toString(this_0).toLowerCase();
            thisChar = charCodeAt(tmp$ret$2, 0);
            // Inline function 'kotlin.text.lowercaseChar' call
            // Inline function 'kotlin.text.lowercase' call
            var this_1 = otherChar;
            // Inline function 'kotlin.js.asDynamic' call
            // Inline function 'kotlin.js.unsafeCast' call
            var tmp$ret$6 = toString(this_1).toLowerCase();
            otherChar = charCodeAt(tmp$ret$6, 0);
            if (!(thisChar === otherChar)) {
              return Char__compareTo_impl_ypi4mb(thisChar, otherChar);
            }
          }
        }
      }
       while (inductionVariable < min);
    return n1 - n2 | 0;
  } else {
    return compareTo(_this__u8e3s4, other);
  }
}
function concatToString(_this__u8e3s4) {
  _init_properties_stringJs_kt__bg7zye();
  if (_this__u8e3s4.length <= 4096) {
    return String.fromCharCode.apply(null, _this__u8e3s4);
  }
  var result = '';
  var start = 0;
  while (start < _this__u8e3s4.length) {
    var tmp0 = start + 4096 | 0;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = _this__u8e3s4.length;
    var end = Math.min(tmp0, b);
    // Inline function 'kotlin.js.asDynamic' call
    var chunk = _this__u8e3s4.subarray(start, end);
    result = result + String.fromCharCode.apply(null, chunk);
    start = end;
  }
  return result;
}
function concatToString_0(_this__u8e3s4, startIndex, endIndex) {
  startIndex = startIndex === VOID ? 0 : startIndex;
  endIndex = endIndex === VOID ? _this__u8e3s4.length : endIndex;
  _init_properties_stringJs_kt__bg7zye();
  Companion_instance.gh(startIndex, endIndex, _this__u8e3s4.length);
  var result = '';
  var start = startIndex;
  while (start < endIndex) {
    // Inline function 'kotlin.comparisons.minOf' call
    var a = start + 4096 | 0;
    var end = Math.min(a, endIndex);
    // Inline function 'kotlin.js.asDynamic' call
    var chunk = _this__u8e3s4.subarray(start, end);
    result = result + String.fromCharCode.apply(null, chunk);
    start = end;
  }
  return result;
}
function encodeToByteArray(_this__u8e3s4) {
  _init_properties_stringJs_kt__bg7zye();
  return encodeUtf8(_this__u8e3s4, 0, _this__u8e3s4.length, false);
}
function decodeToString(_this__u8e3s4, startIndex, endIndex, throwOnInvalidSequence) {
  startIndex = startIndex === VOID ? 0 : startIndex;
  endIndex = endIndex === VOID ? _this__u8e3s4.length : endIndex;
  throwOnInvalidSequence = throwOnInvalidSequence === VOID ? false : throwOnInvalidSequence;
  _init_properties_stringJs_kt__bg7zye();
  Companion_instance.gh(startIndex, endIndex, _this__u8e3s4.length);
  return decodeUtf8(_this__u8e3s4, startIndex, endIndex, throwOnInvalidSequence);
}
function decodeToString_0(_this__u8e3s4) {
  _init_properties_stringJs_kt__bg7zye();
  return decodeUtf8(_this__u8e3s4, 0, _this__u8e3s4.length, false);
}
function toCharArray(_this__u8e3s4) {
  _init_properties_stringJs_kt__bg7zye();
  var tmp = 0;
  var tmp_0 = _this__u8e3s4.length;
  var tmp_1 = charArray(tmp_0);
  while (tmp < tmp_0) {
    var tmp_2 = tmp;
    tmp_1[tmp_2] = charCodeAt(_this__u8e3s4, tmp_2);
    tmp = tmp + 1 | 0;
  }
  return tmp_1;
}
function toCharArray_0(_this__u8e3s4, destination, destinationOffset, startIndex, endIndex) {
  destinationOffset = destinationOffset === VOID ? 0 : destinationOffset;
  startIndex = startIndex === VOID ? 0 : startIndex;
  endIndex = endIndex === VOID ? _this__u8e3s4.length : endIndex;
  _init_properties_stringJs_kt__bg7zye();
  Companion_instance.gh(startIndex, endIndex, _this__u8e3s4.length);
  Companion_instance.gh(destinationOffset, (destinationOffset + endIndex | 0) - startIndex | 0, destination.length);
  var destIndex = destinationOffset;
  var inductionVariable = startIndex;
  if (inductionVariable < endIndex)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var _unary__edvuaz = destIndex;
      destIndex = _unary__edvuaz + 1 | 0;
      destination[_unary__edvuaz] = charCodeAt(_this__u8e3s4, i);
    }
     while (inductionVariable < endIndex);
  return destination;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.mh_1 = function_0;
      }
      nh(a, b) {
        return this.mh_1(a, b);
      }
      compare(a, b) {
        return this.nh(a, b);
      }
      j5() {
        return this.mh_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.j5(), other.j5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.j5());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function STRING_CASE_INSENSITIVE_ORDER$lambda(a, b) {
  _init_properties_stringJs_kt__bg7zye();
  return compareTo_0(a, b, true);
}
var properties_initialized_stringJs_kt_nta8o4;
function _init_properties_stringJs_kt__bg7zye() {
  if (!properties_initialized_stringJs_kt_nta8o4) {
    properties_initialized_stringJs_kt_nta8o4 = true;
    var tmp = STRING_CASE_INSENSITIVE_ORDER$lambda;
    STRING_CASE_INSENSITIVE_ORDER = new (sam$kotlin_Comparator$0())(tmp);
  }
}
//region block: exports
export {
  concatToString as concatToString2syawgu50khxi,
  concatToString_0 as concatToString3cxf0c1gqonpo,
  decodeToString_0 as decodeToString1x4faah2liw2p,
  decodeToString as decodeToString1dbzcjd620q25,
  encodeToByteArray as encodeToByteArray1onwao0uakjfh,
  substring_0 as substring3saq8ornu0luv,
  substring as substringiqarkczpya5m,
  toCharArray as toCharArray32huqyw9tt7kx,
  toCharArray_0 as toCharArrayxsf0njqv61ha,
};
//endregion

//# sourceMappingURL=stringJs.mjs.map
